import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, FormattedDate } from 'react-intl';

const FileMetadata = ({ data }) => {
  let snippet;
  if (data.length > 0) {
    snippet = data
      .filter(item => item.value !== null)
      .map(item => (
        <Fragment key={item.value}>
          <span className="text-muted small">
            {item.value && (
              <Fragment>
                <FormattedMessage id={item.formatString} />
                {' '}
                <FormattedDate
                  value={item.value}
                  year="numeric"
                  month="long"
                  day="2-digit"
                />
                {' '}
              </Fragment>
            )}
          </span><br />
        </Fragment>));
  }

  return snippet || null;
};


FileMetadata.defaultProps = {
  data: [],
};

FileMetadata.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.any,
    formatString: PropTypes.string,
  })),
};

export default FileMetadata;



// WEBPACK FOOTER //
// ./src/components/FileMetadata/FileMetadata.jsx